// @flow
import * as React from 'react';
import { useLocaleConfig } from './useLocaleConfig';
import DateTimeUtils from 'common/utils/DateTimeUtils';
import { ApiStatusEnum } from 'common/enums/API';
import { Loader } from '@locus-taxy/neo-ui';
import { RetrySnackbar } from 'common/components/core/snackbar';
import { useTranslation } from 'react-i18next';

type Props = { children: React.Node };

export const LocaleConfigFetcher = ({ children }: Props): React.Node => {
    const { data, status, refetch } = useLocaleConfig();
    const [isDataLoaded, setIsDataLoaded] = React.useState(false);
    const { t } = useTranslation();

    React.useEffect(() => {
        if (data) {
            const {
                locale,
                localeSettings: {
                    dateFormat: { frontend }
                }
            } = data;

            DateTimeUtils.initialize(locale, frontend);
            setIsDataLoaded(true);
        }
    }, [data]);

    if (status === ApiStatusEnum.Loading) {
        return (
            <Loader width="100%" height="100%" size="large" color="blue.500" />
        );
    }

    if (status === ApiStatusEnum.Error) {
        return (
            <RetrySnackbar
                errorMessage={t('errorTranslatingMessage')}
                active
                isLoading={false}
                onClick={() => refetch()}
            />
        );
    }

    // NOTE: after fetching the locale, we are updating DateTimeUtils in the useEffect
    // so waiting for it to finish
    if (!isDataLoaded) {
        return (
            <Loader width="100%" height="100%" size="large" color="blue.500" />
        );
    }

    return children;
};
